import { useEffect, useRef } from "react";

import { cn } from "@/shared/lib/utils";

export interface StatementPageProps {
  pageIndex: number;
  children: React.ReactNode;
  className?: string;
}

/**
 * One A4 sheet. Fixed height comes from statementPrint.css so the same element is a paper preview on screen
 * and a real page when printed. In dev it warns when its content overflows, which is the signal that the
 * rows-per-page constants need adjusting.
 */
export const StatementPage = ({ pageIndex, children, className }: StatementPageProps) => {
  const ref = useRef<HTMLElement>(null);

  useEffect(() => {
    if (!import.meta.env.DEV) return;
    const el = ref.current;
    if (!el) return;
    if (el.scrollHeight > el.clientHeight) {
      console.warn(
        `[statement] page ${pageIndex + 1} overflows its A4 sheet by ${el.scrollHeight - el.clientHeight}px — lower STATEMENT_FIRST_PAGE_ROWS / STATEMENT_CONT_PAGE_ROWS.`,
      );
    }
  }, [pageIndex, children]);

  return (
    <article
      ref={ref}
      className={cn(
        "statement-page statement-paper flex flex-col bg-card text-foreground shadow-lg print:shadow-none",
        className,
      )}
    >
      {children}
    </article>
  );
};
